import React, { createContext, useContext, ReactNode } from "react";
import { useFetchRegionSettings } from "../hooks/regionSettingsHooks";
import { RegionSettings } from "../api/regionSettings";

interface RegionSettingsContextType {
  regionSettings: RegionSettings | null;
  isLoading: boolean;
  isFeatureEnabled: (feature: keyof Omit<RegionSettings, "id" | "region">) => boolean;
}

const RegionSettingsContext = createContext<RegionSettingsContextType>({
  regionSettings: null,
  isLoading: true,
  isFeatureEnabled: () => false,
});

export const useRegionSettings = () => useContext(RegionSettingsContext);

export const RegionSettingsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { data: regionSettings, isLoading } = useFetchRegionSettings();

  const isFeatureEnabled = (feature: keyof Omit<RegionSettings, "id" | "region">): boolean => {
    if (!regionSettings) return false;
    return !!regionSettings[feature];
  };

  return (
    <RegionSettingsContext.Provider
      value={{
        regionSettings: regionSettings || null,
        isLoading,
        isFeatureEnabled,
      }}
    >
      {children}
    </RegionSettingsContext.Provider>
  );
};

export default RegionSettingsProvider;
